import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorridorTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CorridorTypeCreateDto,
  CorridorTypeDto,
  CorridorTypeExcelDownloadDto,
  CorridorTypeUpdateDto,
} from '../proxy/controlling/dtos/corridor-type';
import { CORRIDORTYPE_CONFIG, CORRIDORTYPE_FIELDS } from './corridor-type.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-corridor-type',
  imports: [
    CommonModule,
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, CorridorTypeService, ConfirmationService],
  templateUrl: './corridor-type.html',
  styleUrl: './corridor-type.scss',
})
export class CorridorType extends BaseHierarchicalCrudComponent<
  CorridorTypeDto,
  CorridorTypeCreateDto,
  CorridorTypeUpdateDto,
  CorridorTypeExcelDownloadDto
> {
  service = inject(CorridorTypeService);
  config = CORRIDORTYPE_CONFIG;
  fields = CORRIDORTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CorridorTypeDto): CorridorTypeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CorridorType';
  }
}
